import PropTypes from "prop-types";

const CartIcon = ({ fill }) => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <symbol id="sp-basket-theme-02" viewBox="0 0 22 20">
        <circle fill={fill} cx="17" cy="18" r="2" />
        <circle fill={fill} cx="8" cy="18" r="2" />
        <path
          fill={fill}
          d="M0 2h3.5L6 14h13l3-10H10l1 2h8.3l-1.6 6H7.5L5 0H0z"
        />
      </symbol>
      <use href="#sp-basket-theme-02" />
    </svg>
  );
};

CartIcon.propTypes = {
  fill: PropTypes.string,
};
export default CartIcon;
